import {
    DisclosuresStatisticsDocument,
    DisclosuresStatisticsQuery,
    DisclosuresStatisticsQueryVariables,
    TenantModulesDocument,
} from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { authVar, tenantModulesVar } from '@boot/reactiveVariables';

interface UseDisclosuresStatisticsProps
    extends QueryHookOptions<
        DisclosuresStatisticsQuery,
        DisclosuresStatisticsQueryVariables
    > {}

/**
 * Use with "cache-only" only! Other options are for `useNotification`, which can send request to the server.
 */
export const useDisclosuresStatistics = (
    props?: UseDisclosuresStatisticsProps,
) => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;
    const { data: tenantData } = useQuery(TenantModulesDocument, {
        onCompleted: ({ tenant }) => {
            tenantModulesVar(tenant.modules);
        },
        skip: !isLoggedIn,
    });

    return useQuery(DisclosuresStatisticsDocument, {
        skip: !tenantData?.tenant.modules.disclosures || !isLoggedIn,
        ...props,
    });
};
